import axios from 'axios';
import { API_Base } from './config';

const chatAPI = {
  // Get chat messages for an event
  getChatMessages: async (eventId) => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.get(`${API_Base}/api/events/${eventId}/chat/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching chat messages:', error);
      throw error;
    }
  },

  // Send a message
  sendMessage: async (eventId, message) => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.post(
        `${API_Base}/api/events/${eventId}/chat/send/`,
        { message },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  },

  // Delete a message
  deleteMessage: async (eventId, messageId) => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.delete(
        `${API_Base}/api/events/${eventId}/chat/${messageId}/delete/`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting message:', error);
      throw error;
    }
  },

  // Mark messages as read
  markAsRead: async (eventId) => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.post(
        `${API_Base}/api/events/${eventId}/chat/mark-read/`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error marking messages as read:', error);
      throw error;
    }
  },

  // Get unread count
  getUnreadCount: async (eventId) => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.get(`${API_Base}/api/events/${eventId}/chat/unread-count/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  },

  // Get stakeholders
  getStakeholders: async (eventId) => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.get(`${API_Base}/api/events/${eventId}/chat/stakeholders/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching stakeholders:', error);
      throw error;
    }
  },

  // Get user's event chats overview
  getUserEventChats: async () => {
    try {
      const token = sessionStorage.getItem('access_token');
      const response = await axios.get(`${API_Base}/api/user/event-chats/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user event chats:', error);
      throw error;
    }
  }
};

export default chatAPI;
